<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14vDCjW/tc-custom/9781504016612.jpg?1718106148232" alt="This image is the cover for the book Tragedy of Z, Drury Lane Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tragedy of Z, Drury Lane Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Patience Thumm, the adventurous daughter of an NYPD inspector, teams up with actor Drury Lane to solve the mystery of a senator’s murder.</b><br/><br/> Patience Thumm has just traveled the world. She turned heads in London, sipped absinthe in Tunis, and debated philosophy on the Left Bank of Paris. When she returns home to New York with a smuggled copy of <i>Lady Chatterley’s Lover</i> in her bag, her father, the NYPD’s Inspector Thumm, is quite unprepared to handle her. At first, it seems they have nothing in common—but the two soon discover a shared appetite for murder.<br/>  <br/> When a corrupt senator is stabbed to death in his study, Patience can’t resist hunting for the killer. With the help of her father’s old friend Drury Lane, the legendary Shakespearean actor, she will find that all the exotic cities of the world can’t offer anything as exciting as a New York homicide.  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellery Queen
      </h2>
      
      <p class="authorDescription body article">Ellery Queen was a pen name created and shared by two cousins, Frederic Dannay (1905&ndash;1982) and Manfred B. Lee (1905&ndash;1971), as well as the name of their most famous detective. Born in Brooklyn, they spent forty-two years writing, editing, and anthologizing under the name, gaining a reputation as the foremost American authors of the Golden Age &ldquo;fair play&rdquo; mystery.&#160;Although eventually famous on television and radio, Queen&rsquo;s first appearance came in 1928, when the cousins won a mystery-writing contest with the book that would eventually be published as <i>The Roman Hat Mystery</i>. Their character was an amateur detective who uses his spare time to assist his police inspector uncle in solving baffling crimes. Besides writing the Queen novels, Dannay and Lee cofounded <i>Ellery Queen&rsquo;s Mystery Magazine</i>, one of the most influential crime publications of all time. Although Dannay outlived his cousin by nine years, he retired Queen upon Lee&rsquo;s death. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e22575c6